import { ng } from "../ngds";
import { Lang, ITranslationDatabase } from "../types/sharedTypes";
import { createDefaultLoadcase, createDefaultLoadcombination } from "./defaultObject";
import { getSec, getMtrl } from "./protoGen";
// import md5 from "md5"

export type SymbolName = "R" | "N" | "V1" | "V2" | "T" | "M1" | "M2" | "u" | "v" | "w" | "d" | "wk" | "vp";

export const LOAD_CASE_TYPES_FOR_DROPDOWN_G1 = [
  { name: "type_permanent_load_", id: ng.loadcase.Type.TYPE_PERMANENT_LOAD },
  { name: "type_imposed_load_", id: ng.loadcase.Type.TYPE_IMPOSED_LOAD },
  { name: "type_wind_load_", id: ng.loadcase.Type.TYPE_WIND_LOAD },
  { name: "type_snow_load_", id: ng.loadcase.Type.TYPE_SNOW_LOAD },
  { name: "type_ice_load_", id: ng.loadcase.Type.TYPE_ICE_LOAD },
  { name: "type_soil_load_", id: ng.loadcase.Type.TYPE_SOIL_LOAD },
  { name: "type_accident_load_", id: ng.loadcase.Type.TYPE_ACCIDENT_LOAD },
  { name: "type_seismic_load_", id: ng.loadcase.Type.TYPE_SEISMIC_LOAD },
];

export const LOAD_CASE_TYPES_FOR_DROPDOWN_G2 = [
  { name: "type_permanent_load_", id: ng.loadcase.Type.TYPE_PERMANENT_LOAD },
  { name: "type_imposed_load_", id: ng.loadcase.Type.TYPE_IMPOSED_LOAD },
  { name: "type_wind_load_", id: ng.loadcase.Type.TYPE_WIND_LOAD },
  { name: "type_snow_load_", id: ng.loadcase.Type.TYPE_SNOW_LOAD },
  { name: "type_ice_load_", id: ng.loadcase.Type.TYPE_ICE_LOAD },
  { name: "type_temperature_load_", id: ng.loadcase.Type.TYPE_TEMPERATURE_LOAD },
  { name: "type_soil_load_", id: ng.loadcase.Type.TYPE_SOIL_LOAD },
  { name: "type_accident_load_", id: ng.loadcase.Type.TYPE_ACCIDENT_LOAD },
  { name: "type_seismic_load_", id: ng.loadcase.Type.TYPE_SEISMIC_LOAD },
  { name: "type_construction_load_", id: ng.loadcase.Type.TYPE_CONSTRUCTION_LOAD },
];

export const LOAD_COMBINATION_TYPES_FOR_DROPDOWN = [
  { name: "type_characteristic_", id: ng.loadcombination.Type.TYPE_CHARACTERISTIC },
  { name: "type_frequent_", id: ng.loadcombination.Type.TYPE_FREQUENT },
  { name: "type_quasi_perm_", id: ng.loadcombination.Type.TYPE_QUASI_PERMANENT },
  { name: "type_ultimate_", id: ng.loadcombination.Type.TYPE_ULTIMATE },
  { name: "type_accidental_", id: ng.loadcombination.Type.TYPE_ACCIDENTAL },
  { name: "type_fire_", id: ng.loadcombination.Type.TYPE_FIRE },
  { name: "type_seismic_", id: ng.loadcombination.Type.TYPE_SEISMIC },
];

export const LOADCASE_CATEGORIES_FOR_DROPDOWN_G1 = [
  { name: "loadcase_category_A_", id: ng.loadcase.Category.CATEGORY_A },
  { name: "loadcase_category_B_", id: ng.loadcase.Category.CATEGORY_B },
  { name: "loadcase_category_C_", id: ng.loadcase.Category.CATEGORY_C },
  { name: "loadcase_category_D_", id: ng.loadcase.Category.CATEGORY_D },
  { name: "loadcase_category_E_", id: ng.loadcase.Category.CATEGORY_E },
  { name: "loadcase_category_F_", id: ng.loadcase.Category.CATEGORY_F },
  { name: "loadcase_category_G_", id: ng.loadcase.Category.CATEGORY_G },
  { name: "loadcase_category_H_", id: ng.loadcase.Category.CATEGORY_H },
];

export const LOADCASE_CATEGORIES_FOR_DROPDOWN_G2 = [
  { name: "loadcase_category_A_", id: ng.loadcase.Category.CATEGORY_A },
  { name: "loadcase_category_B_", id: ng.loadcase.Category.CATEGORY_B },
  { name: "loadcase_category_C_", id: ng.loadcase.Category.CATEGORY_C },
  { name: "loadcase_category_D_", id: ng.loadcase.Category.CATEGORY_D },
  { name: "loadcase_category_E_", id: ng.loadcase.Category.CATEGORY_E },
  { name: "loadcase_category_F_", id: ng.loadcase.Category.CATEGORY_F },
  { name: "loadcase_category_G_", id: ng.loadcase.Category.CATEGORY_G },
  { name: "loadcase_category_H_forG2_", id: ng.loadcase.Category.CATEGORY_H },
  { name: "loadcase_category_G2_", id: ng.loadcase.Category.CATEGORY_G2 },
  { name: "loadcase_category_I1_", id: ng.loadcase.Category.CATEGORY_I1 },
  { name: "loadcase_category_I2_", id: ng.loadcase.Category.CATEGORY_I2 },
  { name: "loadcase_category_I3_", id: ng.loadcase.Category.CATEGORY_I3 },
  { name: "loadcase_category_K_", id: ng.loadcase.Category.CATEGORY_K },
  { name: "loadcase_category_S1_", id: ng.loadcase.Category.CATEGORY_S1 },
  { name: "loadcase_category_S2_", id: ng.loadcase.Category.CATEGORY_S2 },
  { name: "loadcase_category_S3_C_G_", id: ng.loadcase.Category.CATEGORY_S3_C_G },
  { name: "loadcase_category_S3_H_K_", id: ng.loadcase.Category.CATEGORY_S3_H_K },
  { name: "loadcase_category_T_", id: ng.loadcase.Category.CATEGORY_T },
];

export const DURATION_CLASSES_FOR_DROPDOWN = [
  { name: "duration_class_permanent_", id: ng.loadcase.DurationClass.DURATION_CLASS_PERMANENT },
  { name: "duration_class_long_", id: ng.loadcase.DurationClass.DURATION_CLASS_LONG },
  { name: "duration_class_medium_", id: ng.loadcase.DurationClass.DURATION_CLASS_MEDIUM },
  { name: "duration_class_short_", id: ng.loadcase.DurationClass.DURATION_CLASS_SHORT },
  { name: "duration_class_instantaneous_", id: ng.loadcase.DurationClass.DURATION_CLASS_INSTANTANEOUS },
];

export const COA_TYPE_G1 = [
  { name: "uls_type_610_", id: ng.loadcombination.CoaType.COA_TYPE_610 },
  { name: "uls_type_610a_", id: ng.loadcombination.CoaType.COA_TYPE_610A },
  { name: "uls_type_610b_", id: ng.loadcombination.CoaType.COA_TYPE_610B },
  { name: "uls_type_611ab_", id: ng.loadcombination.CoaType.COA_TYPE_611AB },
  { name: "sls_type_614b_", id: ng.loadcombination.CoaType.COA_TYPE_614B },
  { name: "sls_type_615b_", id: ng.loadcombination.CoaType.COA_TYPE_615B },
  { name: "sls_type_616b_", id: ng.loadcombination.CoaType.COA_TYPE_616B },
];

export const COA_TYPE_G2 = [
  { name: "uls_type_812_", id: ng.loadcombination.CoaType.COA_TYPE_812 },
  { name: "uls_type_813a_", id: ng.loadcombination.CoaType.COA_TYPE_813A },
  { name: "uls_type_813b_", id: ng.loadcombination.CoaType.COA_TYPE_813B },
  { name: "uls_type_814a_", id: ng.loadcombination.CoaType.COA_TYPE_814A },
  { name: "uls_type_814b_", id: ng.loadcombination.CoaType.COA_TYPE_814B },
  { name: "uls_type_815_", id: ng.loadcombination.CoaType.COA_TYPE_815 },
  { name: "uls_type_816_", id: ng.loadcombination.CoaType.COA_TYPE_816 },
  { name: "sls_type_829_", id: ng.loadcombination.CoaType.COA_TYPE_829 },
  { name: "sls_type_830_", id: ng.loadcombination.CoaType.COA_TYPE_830 },
  { name: "sls_type_831_", id: ng.loadcombination.CoaType.COA_TYPE_831 },
];

export class Vector {
  data: ng.geometry.Vector3D;
  constructor(x: number, y: number, z: number) {
    this.data = ng.geometry.Vector3D.create({ x: x, y: y, z: z });
  }

  length() {
    return Math.hypot(this.data.x, this.data.y, this.data.z);
  }

  dotProduct(v: Vector) {
    return this.data.x * v.data.x + this.data.y * v.data.y + this.data.z * v.data.z;
  }

  crossProduct(v: Vector) {
    return new Vector(
      this.data.y * v.data.z - this.data.z * v.data.y,
      this.data.z * v.data.x - this.data.x * v.data.z,
      this.data.x * v.data.y - this.data.y * v.data.x,
    );
  }

  angleBetween(vx: Vector) {
    let angle = Math.acos(this.dotProduct(vx) / (this.length() * vx.length()));
    let cross = this.crossProduct(vx);
    let n = cross.data.y;
    if (n < 0) {
      angle *= -1;
    }
    return angle;
  }
}

interface VectorLike {
  x: number;
  y: number;
  z: number;
}

export function createID(name: string) {
  const newID = ng.utils.ID.create({
    guid: CreateGUID(),
    name: name,
    eTag: "",
  });

  return newID;
}

export function DeriveRot(v: VectorLike) {
  if (v.x === null || v.y === null || v.z === null) return Math.PI;

  const vx = new Vector(1.0, 0.0, 0.0);
  const vi = new Vector(v.x, v.y, v.z);

  let rot = vi.angleBetween(vx);

  return rot;
}

export function DeriveDir(angle: number) {
  let x = Math.cos(angle);
  let y = 0;
  let z = Math.sin(angle);

  return ng.geometry.Vector3D.create({ x: x, y: y, z: z });
}

export function CreateGUID() {
  return crypto.randomUUID();
}

export type ErrorType = "error_" | "warning_" | "warning_unstable" | "information_";

export const AddToastWarning = (localisation: ITranslationDatabase, lang: Lang, textLabel: string) => {
  let context = "";
  let text = textLabel; // getLabel(localisation, lang, textLabel);
  const status = "warning_"; // getLabel(localisation, lang, "warning_");
};

// Sends the entire project to the server for updating the gamma values (and adjecent values)
export const updateGamma = async (project: ng.project.Data, token: string) => {
  if (project === null) {
    console.log("updateGamma: project is undefined or null");
  }
  console.log(" proj ", JSON.stringify(project, null, 2));
  // Call the code service to update the load combination factors
  let resp = await fetch("/code/updateGamma", {});
  let js = await resp.json();
  let output = ng.project.Data.fromObject(js);

  return output;
};

// Sends the entire project to the server for updating the load combination factors
export const updateLoadCombFactors = (
  project: ng.project.Data,
  localisation: ITranslationDatabase,
  lang: Lang,
  fPushChg: () => void,
) => {
  let input = ng.endpoint_args.eurocode.UpdateFactorsArgsIn.create({ input: project.input });
  /*
  // Call the code service to update the load combination factors
fetch('/code/updateLoadCombFactors', {
    method: 'POST',
    headers: {  'Content-Type': 'application/json' })

  http.post('/code/updateLoadCombFactors',
    ng.endpoint_args.eurocode.UpdateFactorsArgsIn.toObject(input),
    async (output) => {

      // Parse the updated project and update the context
      let argsOut = ng.endpoint_args.eurocode.UpdateFactorsArgsOut.fromObject(output);
      if (context.proj?.data) {
        context.proj.data.input = argsOut.updatedInput;
        fPushChg();
      }

    },
    async (error) => {
      let msg = getLabel(localisation, lang, "MSG_update_factors_failed_", true);
      AlertMessage("error_", getLabel(localisation, lang, "error_"), "", msg);
    });
    */
};

// Returns the material type associated with the current beam
export const getCurrentMaterialType = (project: ng.project.Data) => {
  if (project && project.input) {
    let input = project.input;

    if (input.structures && input.structures[0] && input.structures[0].elements && input.structures[0].elements[0]) {
      let element = input.structures[0].elements[0];

      if (element.element?.type === "beam") {
        let mat = input.mtrlDb.find(
          (mtrl) => mtrl.id?.guid && element?.getBeam()?.mtrlGuid && mtrl.id?.guid === element?.getBeam()?.mtrlGuid,
        );
        if (mat) {
          return mat.type;
        }
      }
    }
  }

  return ng.material.Mtrl.MTRL_UNSPECIFIED;
};

// Returns the material associated with the current beam
export const getCurrentMaterial = (project: ng.project.Data) => {
  if (project && project.input) {
    let input = project.input;

    if (input.structures && input.structures[0] && input.structures[0].elements && input.structures[0].elements[0]) {
      let element = input.structures[0].elements[0];

      if (element.element?.type === "beam") {
        let mat = input.mtrlDb.find(
          (mtrl) => mtrl.id?.guid && element?.getBeam()?.mtrlGuid && mtrl.id?.guid === element?.getBeam()?.mtrlGuid,
        );
        if (mat) {
          return mat;
        }
      }
    }
  }

  return null;
};

const indexOf = <T>(arr: T[] | undefined, index: number): T | undefined => {
  if (arr === undefined) return undefined;
  if (arr.length <= index) return undefined;
  return arr[index];
};

export const getClientId = (): string => {
  const cookieName = "simplex-client-id";
  const match = document.cookie.match(new RegExp("(^| )" + cookieName + "=([^;]+)"));
  let clientId = match ? match[2] : null;

  // Determine parent domain for cookie
  let cookieDomain = "";
  if (window.location.hostname.endsWith(".private.strusoft.com")) {
    cookieDomain = "domain=.private.strusoft.com;";
  } else if (window.location.hostname.endsWith(".onstrusoft.com")) {
    cookieDomain = "domain=.onstrusoft.com;";
  }
  // For localhost, do not set domain

  if (!clientId) {
    clientId = crypto.randomUUID();
    document.cookie = `${cookieName}=${clientId}; ${cookieDomain} path=/; max-age=${10 * 365 * 24 * 60 * 60}`;
  }
  return clientId;
};

// Returns the section associated with the current beam
export const getCurrentSection = (project: ng.project.Data) => {
  if (project && project.input) {
    let input = project.input;

    if (input.structures && input.structures[0] && input.structures[0].elements && input.structures[0].elements[0]) {
      let element = input.structures[0].elements[0];

      const start = indexOf(element?.getBeam()?.segments, 0)?.layer?.start;
      if (start) {
        let secGuid = start.secGuid;
        let sec = input.secDb.find((sec) => sec.id?.guid && sec.id?.guid === secGuid);
        if (sec) {
          return sec;
        }
      }
    }
  }

  return null;
};

// Sends the entire project to the server for all load combinations to be regenerated
export const reGenerateLoadCombs = async (
  proj: ng.project.Data,
  settings: any,
  cache: ng.frontend.beam.EndPointParamCache | undefined,
  localisation: ITranslationDatabase,
  lang: Lang,
  call: () => void,
) => {
  let project = proj.input;
  let structure = ng.structure.Data.create();
  let loading = ng.loading.Data.create();
  let stage = ng.stage.Data.create();

  if (project && project.structures && project.structures[0]?.loading) {
    structure = project.structures[0];
    if (structure.loading) {
      loading = structure.loading;
    }
    if (structure.stages && structure.stages[0]) {
      stage = structure.stages[0];
    }
  }

  if (!proj) throw new Error("c.proj is undefined");
  settings = settings ?? ng.frontend.beam.FrontendData.create();

  // Create a new cache with default values if one does not exist
  let allLoadcases = loading.loadcases.map((lc) => lc.id?.guid).filter((guid) => guid !== undefined) as string[];
  let defaultLCTypes = [ng.loadcombination.Type.TYPE_ULTIMATE];

  if (!cache) {
    cache = ng.frontend.beam.EndPointParamCache.create({
      loadCombGenSettings: ng.endpoint_args.eurocode.LoadCombGenSettings.create({
        lcTypes: defaultLCTypes,
        loadcases: allLoadcases,
        simple: ng.endpoint_args.eurocode.Simple.create({
          includePermanentLoadFavorable: false,
        }),
      }),
      autoDesign: null,
    });

    settings.endpointCache = cache;
  }

  if (cache.loadCombGenSettings === undefined) {
    cache.loadCombGenSettings = ng.endpoint_args.eurocode.LoadCombGenSettings.create({
      lcTypes: defaultLCTypes,
      loadcases: allLoadcases,
      simple: ng.endpoint_args.eurocode.Simple.create({
        includePermanentLoadFavorable: false,
      }),
    });
  }

  // Prepare the input for the load combination generator endpoint
  let input = ng.endpoint_args.eurocode.LoadCombGenArgsIn.create({
    projectData: project,
    settings: cache.loadCombGenSettings,
  });

  // Call the load combination generator endpoint
  let resp = await fetch("/code/generateLoadCombs", {
    method: "POST",
    body: JSON.stringify(ng.endpoint_args.eurocode.LoadCombGenArgsIn.toObject(input)),
  });
  let output = await resp.json();
  // Parse the updated project and update the context
  let argsOut = ng.endpoint_args.eurocode.LoadCombGenArgsOut.fromObject(output);
  if (loading && loading.combinations) {
    // Filter out the user defined load combinations
    let userDefined = loading.combinations.filter((lco) => lco.userDefined === true);

    // Filter out the user defined load combinations, and check if any are deactivated (means all are)
    let generated = loading.combinations.filter((lco) => lco.userDefined === false);

    let deactivated = generated.length === 0 ? true : false;
    for (var lc of generated) {
      if (lc.deactive) {
        deactivated = true;
        break;
      }
    }

    // Re-set deactive flag for the new load combinations
    var newLoadcombinations = [...argsOut.loadcombinations];
    for (var newLC of newLoadcombinations) {
      newLC.deactive = deactivated;
    }

    // Let's overwrite the existing load combinations for now
    loading.combinations = newLoadcombinations;

    // Add the user defined load combinations back
    loading.combinations = loading.combinations.concat(userDefined);

    // Update the stage with the new load combinations guids
    stage.lcombGuids = loading.combinations.map((lco) => lco.id?.guid).filter((guid) => guid !== undefined) as string[];
  }
  // trigger provided callback
  return proj;
};

export const createEnvelopes = (lcos: ng.loadcombination.IData[]) => {
  function filterItems(arr: ng.loadcombination.IData[], query: ng.loadcombination.Type) {
    return arr.filter((e) => e.type === query);
  }

  //----------------------------------------------------
  let tmpLCOs = [];

  //remove the lco's that are deactivated
  for (let lco of lcos) {
    if (!lco.deactive) {
      tmpLCOs.push(lco);
    }
  }

  //first set up an array of active type's
  let types = [];
  for (let lco of tmpLCOs) {
    if (types.findIndex((e) => e === lco.type) === -1) {
      types.push(lco.type);
    }
  }

  //then create an array of lco's (=envelope) for each coa
  for (let type of types) {
    if (type) {
      let env = filterItems(tmpLCOs, type);
      if (env.length > 1) {
        let arrLco = [];
        for (let lco of env) {
          let tmpLco = createDefaultLoadcase(); // yes this is a load combination disguised as a load case
          if (tmpLco.id && lco.id) {
            tmpLco.id.guid = lco.id.guid; // we want to collect the guid of each load combination that should be in the envelope
          }
          arrLco.push(tmpLco);
        }

        //The 'envelope' is a "load combination" made up from all load combinations that has the same type
        let envelope = createDefaultLoadcombination(arrLco);

        if (envelope.id) {
          envelope.type = ng.loadcombination.Type.TYPE_UNSPECIFIED;
          envelope.id.guid = "envelope_" + arrLco[0].id?.guid; //CreateGUID();
          envelope.id.name = "ENV: " + LOAD_COMBINATION_TYPES_FOR_DROPDOWN[type - 1].name || "";
        }

        tmpLCOs.unshift(envelope); // put the envelopes at the beginning of the load combinations
      }
    }
  }

  return tmpLCOs;
};

export const updateActiveLcosInContext = (proj: ng.project.Data) => {
  const loadcombinations = proj?.input?.structures[0].loading?.combinations ?? [];

  const activeLCOs = createEnvelopes(loadcombinations);
  // const hash = (lcos: ng.loadcombination.Data[]) => md5(JSON.stringify(lcos));
  // if (context.activeLCOs === undefined || hash(activeLCOs) !== hash(context.activeLCOs)) {
  // only push if we changed the activeLCOs
  // context.activeLCOs = activeLCOs;
  return activeLCOs;
};

export const IsBucklingOK = (
  proj: ng.project.Data,
  localisation: ITranslationDatabase,
  lang: Lang,

  setSupPos?: (pos: number[]) => void,
  setTopSpanPos?: (pos: number[]) => void,
  setBtmSpanPos?: (pos: number[]) => void,
  setStiffSpanPos?: (pos: number[]) => void,
  setWeakSpanPos?: (pos: number[]) => void,
  setTopBetas?: (betas: number[]) => void,
  setBtmBetas?: (betas: number[]) => void,
  setStiffBetas?: (betas: number[]) => void,
  setWeakBetas?: (betas: number[]) => void,
  setEdgeSpanPos?: (pos: number[]) => void,
  setLtsCond?: (cond: ng.beam.SupportCondition[]) => void,
) => {
  let project = proj.input;
  let structure = new ng.structure.Data();
  let element = new ng.element.Data();
  let genBeam = new ng.beam.Data();
  let beam: ng.beam.SteelElement | ng.beam.TimberElement | ng.beam.ConcreteElement | null = null;
  let seg = new ng.beam.Segment();
  let elemL: number = 0;
  let stage = new ng.stage.Data();

  if (project && project.structures && project.structures[0]?.loading) {
    structure = project.structures[0];
    if (structure.stages && structure.stages[0]) {
      stage = structure.stages[0];
    }

    if (structure.elements && structure.elements[0]) {
      element = structure.elements[0];
      if (element.element?.type === "beam") {
        genBeam = element.element.beam;
        if (genBeam.segments) {
          seg = genBeam.segments[0];
          elemL = seg.length || 0;
        }

        //steel
        if (genBeam.element?.type === "steel") {
          beam = genBeam.element.steel;
        }
        //timber
        if (genBeam.element?.type === "timber") {
          beam = genBeam.element.timber;
        }
        //rc
        if (genBeam.element?.type === "concrete") {
          beam = genBeam.element.concrete;
        }
      }
    }
  }

  const weakPos = getBucklingPositions(stage, "weak");

  let topBetas: number[] = [];
  let btmBetas: number[] = [];
  let topPos: number[] = [];
  let btmPos: number[] = [];
  let supCond: ng.beam.SupportCondition[] = [];
  let edgePos: number[] = [];

  if (beam instanceof ng.beam.SteelElement) {
    if (beam.ltbTop) {
      topBetas = beam.ltbTop.betas;
      topPos = getBucklingPositions(stage, "top");
    }
    if (beam.ltbBtm) {
      btmBetas = beam.ltbBtm.betas;
      btmPos = getBucklingPositions(stage, "btm");
    }
  }

  if (beam instanceof ng.beam.TimberElement) {
    if (beam.ltsb) {
      supCond = beam.ltsb.supportConditions;
      edgePos = getBucklingPositions(stage, "top");
    }
  }

  let stiffBetas = beam?.fbStiff?.betas;
  let weakBetas = beam?.fbWeak?.betas;

  let OK = true;

  // supports --------------------------------
  let supPos = [] as number[];
  let tmpPos = [] as number[];

  for (let sup of stage.sups || []) {
    if (!sup.lateral && sup.position?.type === "coord" && sup.position.coord.x != null) {
      tmpPos.push(sup.position.coord.x);
    }
  }
  if (stage.sups) {
    tmpPos.sort(function (a, b) {
      return a - b;
    }); // order
    supPos = structuredClone(tmpPos);
    if (setSupPos) setSupPos(structuredClone(tmpPos));
  }

  // spans ====================================

  // top flange --------------------------------

  if (beam instanceof ng.beam.SteelElement) {
    tmpPos = structuredClone(topPos);
    //add start and end of beam so that beta-curves can be drawn
    tmpPos.unshift(0);
    tmpPos.push(elemL);

    //if normal (not lateral) supports are at this level -> include them as well
    for (let sup of stage.sups || []) {
      if (!sup.lateral && sup.supportLevel === ng.stage.SupportLevel.SUPPORT_LEVEL_TOP) {
        const xCoord = sup.getCoord()?.x;
        if (xCoord) {
          tmpPos.push(xCoord);
        }
      }
    }

    tmpPos = [...new Set(tmpPos)]; //remove duplicates
    tmpPos.sort(function (a, b) {
      return a - b;
    }); // order

    if (tmpPos.length - 1 !== topBetas?.length) {
      //AlertMessage("warning_", getLabel(localisation, lang, "warning_"), "", getLabel(localisation, lang, "MSG_buckling_spans_and_betas_mismatch_"));
      console.log("error in buckling spans/betas");
      OK = false;

      //always let the positions rule over betas i.e. adjust the betas
      if (beam.ltbTop) {
        let ltb = beam.ltbTop.deepClone();

        let betas: number[] = [];
        let data: ng.beam.BucklingData[] = [];

        for (let i = 0; i < tmpPos.length - 1; i++) {
          betas.push(1.0);
          let pos = ng.beam.BucklingSpan.create({ start: tmpPos[i], end: tmpPos[i + 1] });
          let tmp = ng.beam.BucklingData.create({ position: pos, beta: 1.0 });
          data.push(tmp);
        }

        ltb.betas = structuredClone(betas);
        ltb.data = data.map((x) => x.deepClone());

        beam.ltbTop = ltb;

        if (setTopBetas) setTopBetas(structuredClone(betas));
      }
    }

    // secure that the beta values are the same in both betas and in data
    if (beam.ltbTop) {
      for (let i = 0; i < beam.ltbTop?.betas.length; i++) {
        if (beam.ltbTop?.data[i].getBeta() !== beam.ltbTop?.betas[i]) {
          beam.ltbTop.data[i].setBeta(beam.ltbTop.betas[i]);
        }
      }
    }

    if (setTopSpanPos) setTopSpanPos(tmpPos);

    // bottom flange --------------------------------

    tmpPos = structuredClone(btmPos);
    //add start and end of beam so that beta-curves can be drawn
    tmpPos.unshift(0);
    tmpPos.push(elemL);

    //if normal (not lateral) supports are at this level -> include them as well
    for (let sup of stage.sups || []) {
      if (!sup.lateral && sup.supportLevel === ng.stage.SupportLevel.SUPPORT_LEVEL_BOTTOM) {
        const xCoord = sup.getCoord()?.x;
        if (xCoord) {
          tmpPos.push(xCoord);
        }
      }
    }

    tmpPos = [...new Set(tmpPos)]; //remove duplicates
    tmpPos.sort(function (a, b) {
      return a - b;
    }); // order

    if (tmpPos.length - 1 !== btmBetas?.length) {
      //AlertMessage("warning_", getLabel(localisation, lang, "warning_"), "", getLabel(localisation, lang, "MSG_buckling_spans_and_betas_mismatch_"));
      console.log("error in buckling spans/betas");
      OK = false;

      //always let the positions rule over betas i.e. adjust the betas
      if (beam.ltbBtm) {
        let ltb = beam.ltbBtm.deepClone();

        let betas: number[] = [];
        let data: ng.beam.BucklingData[] = [];

        for (let i = 0; i < tmpPos.length - 1; i++) {
          betas.push(1.0);
          let pos = ng.beam.BucklingSpan.create({ start: tmpPos[i], end: tmpPos[i + 1] });
          let tmp = ng.beam.BucklingData.create({ position: pos, beta: 1.0 });
          data.push(tmp);
        }

        ltb.betas = structuredClone(betas);
        ltb.data = data.map((x) => x.deepClone());

        beam.ltbBtm = ltb;

        if (setBtmBetas) setBtmBetas(structuredClone(betas));
      }
    }

    // secure that the beta values are the same in both betas and in data
    if (beam.ltbBtm) {
      for (let i = 0; i < beam.ltbBtm?.betas.length; i++) {
        if (beam.ltbBtm?.data[i].getBeta() !== beam.ltbBtm?.betas[i]) {
          beam.ltbBtm.data[i].setBeta(beam.ltbBtm.betas[i]);
        }
      }
    }

    if (setBtmSpanPos) setBtmSpanPos(tmpPos);
  }

  //stiff --------------------------------

  tmpPos = structuredClone(supPos);
  //add start and end of beam so that beta-curves can be drawn
  tmpPos.unshift(0);
  tmpPos.push(elemL);

  //if normal (not lateral) supports are at this level -> include them as well
  for (let sup of stage.sups || []) {
    if (!sup.lateral) {
      const xCoord = sup.getCoord()?.x;
      if (xCoord) {
        tmpPos.push(xCoord);
      }
    }
  }

  tmpPos = [...new Set(tmpPos)]; //remove duplicates
  tmpPos.sort(function (a, b) {
    return a - b;
  }); // order

  if (tmpPos.length - 1 !== stiffBetas?.length) {
    // AlertMessage("warning_", getLabel(localisation, lang, "warning_"), "", getLabel(localisation, lang, "MSG_buckling_spans_and_betas_mismatch_"));
    console.log("error in buckling spans/betas");
    OK = false;

    //always let the positions rule over betas i.e. adjust the betas
    if (beam && beam.fbStiff) {
      let fb = beam.fbStiff.deepClone();

      let betas: number[] = [];
      let data: ng.beam.BucklingData[] = [];

      for (let i = 0; i < tmpPos.length - 1; i++) {
        betas.push(1.0);
        let pos = ng.beam.BucklingSpan.create({ start: tmpPos[i], end: tmpPos[i + 1] });
        let tmp = ng.beam.BucklingData.create({ position: pos, beta: 1.0 });
        data.push(tmp);
      }

      fb.betas = structuredClone(betas);
      fb.data = data.map((x) => x.deepClone());

      beam.fbStiff = fb;

      if (setStiffBetas) setStiffBetas(structuredClone(betas));
    }
  }

  // secure that the beta values are the same in both betas and in data
  if (beam && beam.fbStiff) {
    for (let i = 0; i < beam.fbStiff?.betas.length; i++) {
      if (beam.fbStiff?.data[i].getBeta() !== beam.fbStiff?.betas[i]) {
        beam.fbStiff.data[i].setBeta(beam.fbStiff.betas[i]);
      }
    }
  }

  if (setStiffSpanPos) setStiffSpanPos(tmpPos);

  // weak --------------------------------

  tmpPos = structuredClone(weakPos);
  //add start and end of beam so that beta-curves can be drawn
  tmpPos.unshift(0);
  tmpPos.push(elemL);

  //if normal (not lateral) supports are at this level -> include them as well
  for (let sup of stage.sups || []) {
    if (!sup.lateral && sup.supportLevel === ng.stage.SupportLevel.SUPPORT_LEVEL_CENTER) {
      const xCoord = sup.getCoord()?.x;
      if (xCoord) {
        tmpPos.push(xCoord);
      }
    }
  }

  tmpPos = [...new Set(tmpPos)]; //remove duplicates
  tmpPos.sort(function (a, b) {
    return a - b;
  }); // order

  if (tmpPos.length - 1 !== weakBetas?.length) {
    //AlertMessage("warning_", getLabel(localisation, lang, "warning_"), "", getLabel(localisation, lang, "MSG_buckling_spans_and_betas_mismatch_"));

    console.log("error in buckling spans/betas");
    OK = false;

    //always let the positions rule over betas i.e. adjust the betas
    if (beam && beam.fbWeak) {
      let fb = beam.fbWeak.deepClone();

      let betas: number[] = [];
      let data: ng.beam.BucklingData[] = [];

      for (let i = 0; i < tmpPos.length - 1; i++) {
        betas.push(1.0);
        let pos = ng.beam.BucklingSpan.create({ start: tmpPos[i], end: tmpPos[i + 1] });
        let tmp = ng.beam.BucklingData.create({ position: pos, beta: 1.0 });
        data.push(tmp);
      }

      fb.betas = structuredClone(betas);
      fb.data = data.map((x) => x.deepClone());

      beam.fbWeak = fb;

      if (setWeakBetas) setWeakBetas(structuredClone(betas));
    }
  }

  // secure that the beta values are the same in both betas and in data
  if (beam && beam.fbWeak) {
    for (let i = 0; i < beam.fbWeak?.betas.length; i++) {
      if (beam.fbWeak?.data[i].getBeta() !== beam.fbWeak?.betas[i]) {
        beam.fbWeak.data[i].setBeta(beam.fbWeak.betas[i]);
      }
    }
  }

  if (setWeakSpanPos) setWeakSpanPos(tmpPos);

  if (beam instanceof ng.beam.TimberElement) {
    // edge --------------------------------

    tmpPos = [...edgePos];
    //add start and end of beam so that beta-curves can be drawn
    tmpPos.unshift(0);
    tmpPos.push(elemL);

    //if normal (not lateral) supports are at this level -> include them as well
    for (let sup of stage.sups || []) {
      if (!sup.lateral && sup.supportLevel === ng.stage.SupportLevel.SUPPORT_LEVEL_TOP) {
        const xCoord = sup.getCoord()?.x;
        if (xCoord) {
          tmpPos.push(xCoord);
        }
      }
    }

    tmpPos = [...new Set(tmpPos)]; //remove duplicates
    tmpPos.sort(function (a, b) {
      return a - b;
    }); // order

    if (tmpPos.length - 1 !== supCond?.length) {
      //AlertMessage("warning_", getLabel(localisation, lang, "warning_"), "", getLabel(localisation, lang, "MSG_buckling_spans_and_betas_mismatch_"));
      console.log("error in buckling spans/betas");
      OK = false;

      //always let the positions rule over betas i.e. adjust the betas
      if (beam.ltsb) {
        let ltsb = beam.ltsb.deepClone();

        let supCond: ng.beam.SupportCondition[] = [];
        let data: ng.beam.BucklingData[] = [];

        for (let i = 0; i < tmpPos.length - 1; i++) {
          supCond.push(ng.beam.SupportCondition.SUPPORT_CONDITION_SIMPLY);
          let pos = ng.beam.BucklingSpan.create({ start: tmpPos[i], end: tmpPos[i + 1] });
          let tmp = ng.beam.BucklingData.create({ position: pos, beta: 1.0 });
          data.push(tmp);
        }

        ltsb.supportConditions = structuredClone(supCond);
        ltsb.data = data.map((x) => x.deepClone());

        beam.ltsb = ltsb;

        if (setLtsCond) setLtsCond(structuredClone(supCond));
      }
    }

    // secure that the support conditions are the same in both supportCondition and in data
    if (beam.ltsb) {
      for (let i = 0; i < beam.ltsb?.supportConditions.length; i++) {
        if (beam.ltsb?.data[i].getSupportCondition() !== beam.ltsb?.supportConditions[i]) {
          beam.ltsb.data[i].setSupportCondition(beam.ltsb.supportConditions[i]);
        }
      }
    }

    if (setEdgeSpanPos) setEdgeSpanPos(tmpPos);
  }

  ///if (!OK && pushChanges) pushChanges(context);

  return OK;
};

export const CheckLoadDir = (proj: ng.project.Data) => {
  let project = proj?.input;
  let loads: ng.load.IData[] = [];

  if (project && project.structures && project.structures[0]?.loading) {
    loads = project.structures[0].loading.loads || [];

    let tmpLoads = loads.map((x) => x.deepClone());

    for (let load of tmpLoads) {
      if (load.direction) {
        let dir = load.direction;

        load.direction.x = Math.abs(dir.x) < 1e-6 ? 0 : dir.x;
        load.direction.y = dir.y;
        load.direction.z = 1 - Math.abs(dir.z) < 1e-6 ? (dir.z > 0 ? 1 : -1) : dir.z;
      }
    }

    project.structures[0].loading.loads = tmpLoads;

    // if (pushChanges) pushChanges(context); need to update sliec
  }

  return true;
};

//================================================================================================

// ======== Section dedicated to handling self-weight =========

export const GetSelfWeightGuid = (lcas: ng.loadcase.IData[]) => {
  let selfWeightGuid = "";
  for (let lca of lcas) {
    if (lca.type === ng.loadcase.Type.TYPE_SELF_WEIGHT) {
      selfWeightGuid = lca.id?.guid || "";
      break;
    }
  }
  return selfWeightGuid;
};

export function getBucklingPositions(indata: ng.stage.IData, loc: string) {
  let pos: number[] = [];

  for (let sup of indata.sups || []) {
    if (sup.lateral) {
      if (loc === "edge") {
        if (sup.supportLevel === ng.stage.SupportLevel.SUPPORT_LEVEL_TOP) {
          //&& sup.con?.transY?.value !== 0
          pos.push(sup.getCoord()?.x || 0);
        }
      }

      if (loc === "btm") {
        if (sup.supportLevel === ng.stage.SupportLevel.SUPPORT_LEVEL_BOTTOM) {
          //&& sup.con?.transY?.value !== 0
          pos.push(sup.getCoord()?.x || 0);
        }
      }

      if (loc === "top") {
        if (sup.supportLevel === ng.stage.SupportLevel.SUPPORT_LEVEL_TOP) {
          //&& sup.con?.transY?.value !== 0
          pos.push(sup.getCoord()?.x || 0);
        }
      }

      if (loc === "weak") {
        if (sup.supportLevel === ng.stage.SupportLevel.SUPPORT_LEVEL_CENTER) {
          //&& sup.con?.transY?.value !== 0
          pos.push(sup.getCoord()?.x || 0);
        }
      }
    } else {
      if (loc === "stiff") {
        pos.push(sup.getCoord()?.x || 0);
      }
    }
  }

  pos = [...new Set(pos)]; //remove duplicates

  pos.sort((a, b) => a - b); //sort ascending

  return pos;
}

const CalculateSelfWeight = (input: ng.endpoint_args.analysis.SelfWeightInput) => {
  let output: ng.endpoint_args.analysis.SelfWeightOutput = ng.endpoint_args.analysis.SelfWeightOutput.create();

  let tmpPos: number[] = [];
  let xPos: number[] = [];

  let x: number = 0;

  tmpPos.push(x); // start position

  let segInd = -1;

  for (let seg of input.segments) {
    segInd++;

    let start_A: number = input.sections[segInd].units?.a || 0;
    let end_A: number = input.sections[segInd + 1].units?.a || 0;

    let rho1: number = input.rho1;
    let rho2: number = input.rho2;

    let L: number = seg.length;
    x += L;
    tmpPos.push(x);

    // reinforcement -----

    if (input.reinfs && input.reinfs.grps.length > 0 && input.reinfs.lays.length > 0) {
      //split the segment based on the groups of reinforcements
      for (let grp of input.reinfs.grps) {
        let x1 = grp.start;
        if (x1 < 0) x1 = 0;
        tmpPos.push(x1);
        let x2 = x1 + grp.length;
        if (x2 > L) x2 = L;
        tmpPos.push(x2);
      }

      // get your ducks in a ordered row
      tmpPos.sort((a, b) => a - b);

      // remove duplicate
      tmpPos = Array.from(new Set(tmpPos));

      // add duplicates at inner positions
      let len = tmpPos.length;
      for (let i = 0; i < len; i++) {
        xPos.push(tmpPos[i]);

        if (i !== 0 && i !== len - 1) {
          xPos.push(tmpPos[i]);
        }
      }

      for (let pos of xPos) {
        output.pos.push(pos);
      }

      let odd: boolean = false;

      for (let xp of xPos) {
        if (odd) {
          xp -= 1e-3;
        } else {
          xp += 1e-3;
        }
        odd = !odd;

        let A = (start_A * (L - xp) + end_A * xp) / L; // interpolated value
        let As = 0;

        //which groups are active at this position?
        for (let grp of input.reinfs.grps) {
          if (xp > grp.start && xp < grp.start + grp.length) {
            let d = grp.diameter * 1e-3;
            let Abar = (Math.PI * d * d) / 4;
            for (let lay of input.reinfs.lays) {
              if (lay.grpGuid === grp.id?.guid) {
                if (lay.getS()) {
                  //               let entry = output.mutable_log -> add_entries;
                  // entry -> set_text("Reinforcements in layers needs to be specified with numbers, not spacing.");
                  // entry -> set_type(ng:: log:: LOG_TYPE_ERROR);
                  return false;
                }

                let n: number = lay.getNum() || 0; // number of bars
                As += n * Abar;
              }
            }
          }
        }

        let g = ((A - As) * rho1 + As * rho2) * input.grav;

        output.loads.push(g);
      }
    } else {
      for (let xp of [0, L]) {
        let A = (start_A * (L - xp) + end_A * xp) / L; // interpolated value
        let g = A * rho1 * input.grav;
        output.pos.push(xp);
        output.loads.push(g);
      }
    }

    ////------------------------------------------------------------------------------

    // if (beam.concrete().has_topping())  // only for concrete beam with topping
    //{
    //     const ng::beam::ConcreteElement_Topping topp = beam.concrete().topping();

    //    const ng::beam::ConcreteElement_Topping_Segment seg = topp.segments(segInd);

    //    if (seg.active())
    //    {
    //        bool retVal = additional_load_from_topping(elem, topp, input, stage, seg, dead_load_start, dead_load_end, pLog);

    //        if (!retVal) return false;
    //    }
    //}

    ////------------------------------------------------------------------------------

    // calc totalt weight of beam --------------------
    let w = 0;

    let dL_vec: number[] = [];

    for (let i = 1; i < xPos.length; i = i + 2) {
      dL_vec.push(xPos[i] - xPos[i - 1]);
    }

    let ind = -1;
    for (let dl of dL_vec) {
      ind++;
      let g1 = output.loads[ind];

      ind++;
      let g2 = output.loads[ind];

      w += ((g1 + g2) / 2.0) * dl;
    }

    output.weight = w;
  }

  return output;
};

// const addSelfWeightLoadcase = (proj: ng.project.Data, user: any, settings: any, localisation: any) => {
//   let input = proj?.input;
//   const lang = user?.settings?.lang ?? "en";
//   let cache = settings?.endpointCache!;

//   let struct = ng.structure.Data.create();
//   let lcas: ng.loadcase.IData[] = [];
//   let lcos: ng.loadcombination.IData[] = [];
//   let loading = ng.loading.Data.create();

//   if (input && input.structures && input.structures[0]?.loading) {
//     struct = input.structures[0];
//     if (struct.loading) {
//       loading = struct.loading;

//       if (loading.loadcases) lcas = loading.loadcases;

//       if (loading.combinations) lcos = loading.combinations;
//     }
//   }

//   //----------------------------------------------------

//   let newLoadcases = [...lcas];

//   const id = createID("self-weight_short_");

//   id.guid = CreateGUID();

//   let lc = ng.loadcase.Data.create({
//     id: id,
//     type: ng.loadcase.Type.TYPE_SELF_WEIGHT,
//     durationClass: ng.loadcase.DurationClass.DURATION_CLASS_PERMANENT,
//     category: ng.loadcase.Category.CATEGORY_UNSPECIFIED,
//     numberOfStoreys: 0,
//     description: "",
//   });

//   newLoadcases?.push(lc);

//   loading.loadcases = newLoadcases;

//   let add = false;
//   for (const lcomb of lcos) {
//     if (lcomb.userDefined === false) {
//       add = true;
//       break;
//     }
//   }

//   // always add self-weight loadcase to auto-generated load combinations if it's active (=in use)
//   if (add) {
//     if (cache && cache.loadCombGenSettings && cache.loadCombGenSettings.loadcases && lc.id) {
//       cache.loadCombGenSettings.loadcases.push(lc.id?.guid);
//     }
//   }

//   return lc;
// };

// const deleteSelfWeightLoadcase = (proj: ng.project.Data, settings: any) => {
//   let input = proj?.input;
//   let cache = settings?.endpointCache!;

//   let struct = ng.structure.Data.create();
//   let lcas: ng.loadcase.IData[] = [];
//   let lcos: ng.loadcombination.IData[] = [];
//   let loading = ng.loading.Data.create();

//   if (input && input.structures && input.structures[0]?.loading) {
//     struct = input.structures[0];
//     if (struct.loading) {
//       loading = struct.loading;

//       if (loading.loadcases) lcas = loading.loadcases;

//       if (loading.combinations) lcos = loading.combinations;
//     }
//   }

//   //-----------------------------------------------

//   let guid = GetSelfWeightGuid(lcas);
//   // const loadcase = lcas?.find(
//   //   (lc: ng.loadcase.IData) => lc.id?.guid === guid
//   // );

//   let newLoadcases = [...lcas];

//   const index = newLoadcases?.findIndex((lc: ng.loadcase.IData) => lc.id?.guid === guid);

//   if (index != null && index > -1) {
//     // remove loadcase from loadcases --------------------------
//     newLoadcases?.splice(index, 1);
//     loading.loadcases = newLoadcases;
//     lcas = newLoadcases;

//     // remove loadcase from loadcombinations generation settings --------------------
//     if (cache && cache.loadCombGenSettings && cache.loadCombGenSettings.loadcases) {
//       let newList = [...cache.loadCombGenSettings.loadcases];
//       const i = newList?.findIndex((lc: string) => lc === guid);
//       if (i != null && i > -1) {
//         newList?.splice(i, 1);
//       }
//       cache.loadCombGenSettings.loadcases = newList;
//     }

//     // remove loadcase from user defined loadcombinations --------------------------
//     let tmpLCOs = [...lcos];
//     let newLCOs = [];
//     for (let tmpLCO of tmpLCOs) {
//       let tmpParts = [];
//       for (let tmpPart of tmpLCO.parts) {
//         if (tmpPart.lcaseGuid !== guid) {
//           tmpParts.push(tmpPart);
//         }
//       }
//       tmpLCO.parts = tmpParts;
//       if (tmpLCO.parts.length > 0) {
//         newLCOs.push(tmpLCO);
//       }
//     }

//     loading.combinations = newLCOs;
//   }
// };

const getLCA = (guid: string, lcas: ng.loadcase.IData[]) => {
  for (let lca of lcas) {
    if (lca.id?.guid === guid) {
      return lca;
    }
  }
};

// const addSelfWeightLoad = async (lca: ng.loadcase.IData, proj: ng.project.Data, minG: number, maxG: number) => {
//   let projInput = proj?.input!;
//   let struct = ng.structure.Data.create();
//   let lcas: ng.loadcase.IData[] = [];
//   let lcos: ng.loadcombination.IData[] = [];
//   let loads: ng.load.IData[] = [];
//   let loading = ng.loading.Data.create();
//   let elem = ng.element.Data.create();
//   let beam = ng.beam.Data.create();
//   let segments: ng.beam.ISegment[] = [];

//   if (projInput && projInput.structures && projInput.structures[0]?.loading) {
//     struct = projInput.structures[0];
//     if (struct.loading) {
//       loading = struct.loading;

//       if (loading.loads) loads = loading.loads;

//       if (loading.loadcases) lcas = loading.loadcases;

//       if (loading.combinations) lcos = loading.combinations;
//     }

//     if (struct.elements && struct.elements[0]) {
//       elem = struct.elements[0];

//       if (elem.element?.type === "beam") {
//         beam = elem.element.beam;
//         if (beam.segments) {
//           segments = beam.segments;
//         }
//       }
//     }
//   }

//   // ------------------- collect segments and sections -------------------
//   let segs: ng.beam.ISegment[] = [];
//   let secs: ng.sections.Section[] = [];

//   for (let seg of segments) {
//     let tmp = ng.beam.Segment.create({
//       length: seg.length,
//     });
//     segs.push(tmp);

//     if (seg.layer?.start?.secGuid) {
//       let tmpSec = getSec(seg.layer?.start?.secGuid, projInput);
//       let tmp = ng.sections.Section.create({
//         units: ng.sections.SectionUnits.create({
//           a: tmpSec?.units?.a ?? 0,
//         }),
//       });
//       secs.push(tmp);
//     }
//   }

//   // last segment
//   let seg = segments[segments.length - 1];
//   if (seg.layer?.end?.secGuid) {
//     let tmpSec = getSec(seg.layer?.end?.secGuid, projInput);
//     let tmp = ng.sections.Section.create({
//       units: ng.sections.SectionUnits.create({
//         a: tmpSec?.units?.a ?? 0,
//       }),
//     });
//     secs.push(tmp);
//   }

//   //----------------- collect rho's and reinforcements for beam ------------------------

//   let grps: ng.reinf.IGroup[] = [];
//   let lays: ng.reinf.ILayer[] = [];
//   let tmpRHO1: number = 0;
//   let tmpRHO2: number = 0;
//   if (beam.mtrlGuid) {
//     let tmpMtrl = getMtrl(beam.mtrlGuid, projInput);

//     switch (tmpMtrl?.type) {
//       case ng.material.Mtrl.MTRL_CONCRETE:
//         tmpRHO1 = tmpMtrl.getConData()?.properties?.density || 0;

//         if (beam.element?.type === "concrete") {
//           if (beam.element.concrete.rebars) {
//             if (beam.element.concrete.rebars.grps) {
//               let get = true;
//               for (let grp of beam.element.concrete.rebars.grps) {
//                 if (grp.mtrlGuid && get) {
//                   get = false;
//                   tmpMtrl = getMtrl(grp.mtrlGuid, projInput);
//                   tmpRHO2 = tmpMtrl?.getReinforcementData()?.properties?.density || 0;
//                 }
//                 let tmp = ng.reinf.Group.create({
//                   id: ng.utils.ID.create({
//                     guid: grp.id?.guid ?? "",
//                   }),
//                   start: grp.start,
//                   length: grp.length,
//                   diameter: grp.diameter,
//                 });
//                 grps.push(tmp);
//               }
//             }
//             if (beam.element.concrete.rebars.lays) {
//               for (let lay of beam.element.concrete.rebars.lays) {
//                 let tmp = ng.reinf.Layer.create({
//                   grpGuid: lay.grpGuid,
//                 });
//                 if (lay.numbers?.type === "num") tmp.setNum(lay.numbers.num);
//                 lays.push(tmp);
//               }
//             }
//           }
//         }

//         break;
//       case ng.material.Mtrl.MTRL_STEEL:
//         tmpRHO1 = tmpMtrl.getSteelData()?.properties?.density || 0;
//         break;
//       case ng.material.Mtrl.MTRL_TIMBER:
//         {
//           const timberData = tmpMtrl.getTimberData();
//           if (timberData?.properties?.type === "boardData") {
//             tmpRHO1 = timberData.properties.boardData.density;
//           } else {
//             tmpRHO1 = timberData?.getSolidData()?.density || 0;
//           }
//         }
//         break;
//       default:
//         tmpRHO1 = 0;
//         break;
//     }
//   }

//   //----------------------------------------------------------------------

//   let input = ng.endpoint_args.analysis.SelfWeightInput.create({
//     sections: secs,
//     segments: segs,
//     rho1: tmpRHO1,
//     rho2: tmpRHO2,
//     grav: 9.81,
//     reinfs: ng.rebar.Data.create({
//       grps: grps,
//       lays: lays,
//     }),
//   });

//   minG = Number.MAX_VALUE;
//   maxG = Number.MIN_VALUE;

//   const load = CalculateSelfWeight(input);

//   if (proj && load) {
//     let tmpLoads: ng.load.IData[] = [];
//     if (loads) {
//       tmpLoads = loads;
//     }

//     let newLoads = [...tmpLoads];

//     let arrLoads = [];

//     for (let ind = 0; ind < load.pos.length; ind = ind + 2) {
//       let g1 = load.loads[ind];
//       let g2 = load.loads[ind + 1];

//       let newLoad = ng.load.Data.create({
//         id: createID("Self-weight"),
//         type: ng.load.Type.TYPE_FORCE,
//         distribution: ng.load.DistributionType.DISTRIBUTION_TYPE_LINE,
//         direction: ng.geometry.Vector3D.create({ x: 0.0, y: 0.0, z: -1.0 }),
//         positions: [
//           ng.geometry.Point3D.create({ x: load.pos[ind], y: 0.0, z: 0.0 }),
//           ng.geometry.Point3D.create({ x: load.pos[ind + 1], y: 0.0, z: 0.0 }),
//         ],
//         values: [g1, g2],
//         lcaseGuid: lca.id?.guid,
//         assignedObjects: [elem.id?.guid as string],
//       });

//       newLoads?.push(newLoad);

//       arrLoads.push(newLoad);

//       if (g1 < minG) {
//         minG = g1;
//       }

//       if (g1 > maxG) {
//         maxG = g1;
//       }

//       if (g2 < minG) {
//         minG = g2;
//       }

//       if (g2 > maxG) {
//         maxG = g2;
//       }
//     }

//     loading.loads = newLoads;
//     loads = newLoads;

//     // update if self-weight loadcase is part of any loadcombination
//     for (let lcomb of lcos) {
//       for (let part of lcomb.parts) {
//         let lca = getLCA(part.lcaseGuid, lcas);
//         if (lca !== undefined) {
//           part.lcaseGuid = lca.id?.guid || ""; // re-direct self-weight loadcase to new guid
//         }
//       }
//     }
//   }
// };

// const deleteSelfWeightLoad = (proj: ng.project.Data) => {
//   let projInput = proj?.input!;
//   let structure = ng.structure.Data.create();
//   let lcas: ng.loadcase.IData[] = [];
//   let loads: ng.load.IData[] = [];
//   let loading = ng.loading.Data.create();

//   if (projInput && projInput.structures && projInput.structures[0]?.loading) {
//     structure = projInput.structures[0];

//     if (structure.loading) {
//       loading = structure.loading;

//       if (loading.loadcases) lcas = loading.loadcases;

//       if (loading.loads) loads = loading.loads;
//     }
//   }

//   //---------------------------------------------------------

//   let guid = GetSelfWeightGuid(lcas);

//   const newLoads = [];

//   for (const tmpLoad of [...loads]) {
//     if (tmpLoad.lcaseGuid !== guid) {
//       newLoads.push(tmpLoad);
//     }
//   }

//   loading.loads = newLoads;
//   loads = newLoads;
// };

// export const addSelfWeigts = (
//   proj: ng.project.Data,
//   user: any,
//   localisation: any,
//   settings: any,
//   minG: number,
//   maxG: number,
// ) => {
//   //add new self-weight load(s) and load case
//   const lc = addSelfWeightLoadcase(proj, user, localisation, settings);
//   addSelfWeightLoad(lc, proj, minG, maxG);
// };

// export const refreshSelfWeight = async (proj: ng.project.Data, minG: number, maxG: number) => {
//   let input = proj?.input;
//   let structure = ng.structure.Data.create();
//   let lcas: ng.loadcase.IData[] = [];
//   let loading = ng.loading.Data.create();

//   if (input && input.structures && input.structures[0]?.loading) {
//     structure = input.structures[0];

//     if (structure.loading) {
//       loading = structure.loading;

//       if (loading.loadcases) lcas = loading.loadcases;
//     }
//   }

//   //---------------------------------------------------------

//   let swGuid = GetSelfWeightGuid(lcas);

//   //remove all self-weight load(s)
//   deleteSelfWeightLoad(proj);

//   const lc = getLCA(swGuid, lcas);

//   if (lc) {
//     addSelfWeightLoad(lc, proj, minG, maxG);
//   }
// };

// export const removeAllSelfWeights = (proj: ng.project.Data, settings: any) => {
//   //remove all self-weight load(s) and load case
//   deleteSelfWeightLoad(proj);
//   deleteSelfWeightLoadcase(proj, settings);
// };

export const interpolate = (
  pos: ng.result.PositionResult,
  prevPos: ng.result.PositionResult,
  endX: number,
  x: number,
  dof: number,
  type: string,
  newPos: ng.result.PositionResult,
) => {
  const x1 = prevPos.getDistance() ?? 0;
  const x2 = endX;
  let y1 = 0;
  let y2 = 0;

  if (type === "force") {
    y1 = prevPos.results?.force?.value[dof] ?? 0;
    y2 = pos.results?.force?.value[dof] ?? 0;
  }

  if (type === "disp") {
    y1 = prevPos.results?.displacement?.value[dof] ?? 0;
    y2 = pos.results?.displacement?.value[dof] ?? 0;
  }

  let val = y1;
  if (Math.abs(x1 - x2) > 2.1e-3) {
    // the distance between two "double"-points is 2 mm so 2.1 assures that we find these
    val = y1 + (y2 - y1) * ((x - x1) / (x2 - x1));
  }

  if (newPos.results) {
    if (type === "force") {
      if (newPos.results.force) {
        newPos.results.force.value[dof] = val;
      }
    }
    if (type === "disp") {
      if (newPos.results.displacement) {
        newPos.results.displacement.value[dof] = val;
      }
    }
  }
};

/**
 * A load combination type as either representation it appears in: the enum on
 * ng.loadcombination.Data, or the proto-json spelling ("TYPE_ULTIMATE") on Data_json.
 */
export type LoadCombinationTypeLike = ng.loadcombination.Type | string | null | undefined;

const toLoadCombinationType = (type: LoadCombinationTypeLike): ng.loadcombination.Type =>
  // Guard the null case ourselves — Type_FromObject would log an "unhandled value" for a
  // combination that simply has no type set.
  type == null ? ng.loadcombination.Type.TYPE_UNSPECIFIED : ng.loadcombination.Type_FromObject(type);

export const isUlsType = (type: LoadCombinationTypeLike) => {
  switch (toLoadCombinationType(type)) {
    case ng.loadcombination.Type.TYPE_ACCIDENTAL:
    case ng.loadcombination.Type.TYPE_FIRE:
    case ng.loadcombination.Type.TYPE_SEISMIC:
    case ng.loadcombination.Type.TYPE_ULTIMATE:
      return true;
    default:
      return false;
  }
};

export const isSlsType = (type: LoadCombinationTypeLike) => {
  switch (toLoadCombinationType(type)) {
    case ng.loadcombination.Type.TYPE_CHARACTERISTIC:
    case ng.loadcombination.Type.TYPE_FREQUENT:
    case ng.loadcombination.Type.TYPE_QUASI_PERMANENT:
      return true;
    default:
      return false;
  }
};

/**
 * Sort rank grouping combinations by limit state: ULS first, SLS next, and anything with an
 * unknown/unspecified type last. See byLimitState for the comparator built on this.
 */
export const getLimitStateRank = (type: LoadCombinationTypeLike): number =>
  isUlsType(type) ? 0 : isSlsType(type) ? 1 : 2;

/**
 * Comparator listing the ULS combinations before the SLS ones. Accepts both Data and Data_json.
 * Array.prototype.sort is stable, so combinations sharing a limit state keep their original order.
 */
export const byLimitState = <T extends { type?: LoadCombinationTypeLike }>(a: T, b: T): number =>
  getLimitStateRank(a.type) - getLimitStateRank(b.type);

export const isULS = (lco: ng.loadcombination.Data) => isUlsType(lco.type);

export const isSLS = (lco: ng.loadcombination.Data) => isSlsType(lco.type);

export const migrateGeneration = (
  input: ng.input.Data,
  fromGen: ng.eurocode.Generation,
  toGen: ng.eurocode.Generation,
): ng.input.Data => {
  if (fromGen === toGen) return input;

  if (!input || !input.getEc()) {
    return input;
  }

  if (fromGen === ng.eurocode.Generation.GENERATION_1 && toGen === ng.eurocode.Generation.GENERATION_2) {
    for (let structure of input.structures || []) {
      if (structure.loading) {
        for (let loadcomb of structure.loading.combinations || []) {
          switch (loadcomb.coa) {
            case ng.loadcombination.CoaType.COA_TYPE_610:
            case ng.loadcombination.CoaType.COA_TYPE_610A:
            case ng.loadcombination.CoaType.COA_TYPE_610B:
            case ng.loadcombination.CoaType.COA_TYPE_610A3:
            case ng.loadcombination.CoaType.COA_TYPE_610B4:
            case ng.loadcombination.CoaType.COA_TYPE_6105:
            case ng.loadcombination.CoaType.COA_TYPE_611AB:
            case ng.loadcombination.CoaType.COA_TYPE_614B:
            case ng.loadcombination.CoaType.COA_TYPE_615B:
            case ng.loadcombination.CoaType.COA_TYPE_616B:
            default:
              break; // do nothing
          }
        }

        for (let loadcomb of structure.loading.combinations || []) {
          // Check for any loadcombination set to old G1 type: ng.loadcase.Type.LIMIT_STATE_STR
          if (loadcomb.limitState === ng.loadcombination.LimitState.LIMIT_STATE_STR) {
            loadcomb.limitState = ng.loadcombination.LimitState.LIMIT_STATE_VC1;
          }
        }
      }
    }
  } else if (fromGen === ng.eurocode.Generation.GENERATION_2 && toGen === ng.eurocode.Generation.GENERATION_1) {
    for (let structure of input.structures || []) {
      if (structure.loading) {
        for (let loadcase of structure.loading.loadcases || []) {
          // Check for any loadcases set to new G2 type: ng.loadcase.Type.TYPE_CONSTRUCTION_LOAD
          if (loadcase.type === ng.loadcase.Type.TYPE_CONSTRUCTION_LOAD) {
            loadcase.type = ng.loadcase.Type.TYPE_IMPOSED_LOAD; // Imposed load seems to be the closest match?
            loadcase.category = ng.loadcase.Category.CATEGORY_D; // Shopping maybe?
          }

          // Check impose loads for categories new for G2
          switch (loadcase.category) {
            case ng.loadcase.Category.CATEGORY_G2:
              loadcase.category = ng.loadcase.Category.CATEGORY_G; // Heavy traffic (general) ?
              break;
            case ng.loadcase.Category.CATEGORY_I1:
            case ng.loadcase.Category.CATEGORY_I2:
            case ng.loadcase.Category.CATEGORY_I3:
            case ng.loadcase.Category.CATEGORY_K:
              loadcase.category = ng.loadcase.Category.CATEGORY_H; // Roof (general) ?
              break;
            case ng.loadcase.Category.CATEGORY_S1:
            case ng.loadcase.Category.CATEGORY_S2:
              loadcase.category = ng.loadcase.Category.CATEGORY_C;
              break;
            case ng.loadcase.Category.CATEGORY_S3_C_G:
              loadcase.category = ng.loadcase.Category.CATEGORY_G; // Worst of C -> G ?
              break;
            case ng.loadcase.Category.CATEGORY_S3_H_K:
              loadcase.category = ng.loadcase.Category.CATEGORY_H; // Only roof (K is G2) ?
              break;
            case ng.loadcase.Category.CATEGORY_T:
              loadcase.category = ng.loadcase.Category.CATEGORY_C; // terraces and balconies -> Congregation maybe ?
              break;
            default:
              break; // do nothing
          }
        }

        for (let loadcomb of structure.loading.combinations || []) {
          // Check for any loadcombination set to new G2 type: ng.loadcase.Type.LIMIT_STATE_VC1
          if (loadcomb.limitState === ng.loadcombination.LimitState.LIMIT_STATE_VC1) {
            loadcomb.limitState = ng.loadcombination.LimitState.LIMIT_STATE_STR;
          }
        }

        // Check for user defined load combinations with new COA unique to G2 set
        for (let loadcomb of structure.loading.combinations || []) {
          switch (loadcomb.coa) {
            case ng.loadcombination.CoaType.COA_TYPE_812:
            case ng.loadcombination.CoaType.COA_TYPE_813A:
            case ng.loadcombination.CoaType.COA_TYPE_813B:
            case ng.loadcombination.CoaType.COA_TYPE_814A:
            case ng.loadcombination.CoaType.COA_TYPE_814B:
            case ng.loadcombination.CoaType.COA_TYPE_815:
            case ng.loadcombination.CoaType.COA_TYPE_816:
            case ng.loadcombination.CoaType.COA_TYPE_829:
            case ng.loadcombination.CoaType.COA_TYPE_830:
            case ng.loadcombination.CoaType.COA_TYPE_831:
            default:
              break; // do nothing
          }
        }
      }

      // Check concrete materials for C100/115
      // update to an G1 equivilent...?
    }
  }

  return input;
};

//==============================================================
